import {
  MAX_HOUR_VALUE,
  MIN_HOUR_VALUE,
} from '@/ui-kit/components/form/controls/components/time-picker/constants';

const MIN_DELAY_FROM_NOW_IN_HOURS = 3;

const GetAvailableHoursRange = {
  methods: {
    getAvailableHoursRange(selectedDate) {
      return selectedDate <= Date.now()
        ? [[new Date().getHours() + MIN_DELAY_FROM_NOW_IN_HOURS, MAX_HOUR_VALUE]]
        : [[MIN_HOUR_VALUE, MAX_HOUR_VALUE]];
    },
  },
};

export default GetAvailableHoursRange;
